//helpers
import { cutText } from "helpers/test"

const MiniQuestion = ({ question }) => {
    return (
        <div className="question" dangerouslySetInnerHTML={{ __html: question }} />
    )
}

export default MiniQuestion